import "react-modern-calendar-datepicker/lib/DatePicker.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import App from "./Container/App";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <ToastContainer rtl />
    </BrowserRouter>
  </React.StrictMode>
);
